export default __webpack_public_path__ + "static/media/closer-tyrfing.da5b5d14.txt";